import React from 'react';
import {useParams} from 'react-router-dom'

const ProductDetail = (props) => {
    let { idRuta } = useParams();
    return (
        
        <div>
            Product Detail
        </div>
    );
};

export default ProductDetail;